<template>
<component :is="block.mode" :block="block" />
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import PageHeroImageMode from './herotypes/PageHeroImageMode';
import PageHeroVideoMode from './herotypes/PageHeroVideoMode';
import PageHeroCarouselMode from './herotypes/PageHeroCarouselMode';
export default {
    name: 'PageHeroBlock',
    mixins: [ BlockCommons ],
    components: {
        PageHeroVideoMode,
        PageHeroImageMode,
        PageHeroCarouselMode
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/PageHeroBlock.vue